// react
import { useContext, useState } from 'react';

// types
import { Tag } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextProject } from '../../pages/Project/Project.context';

// hooks
import { useFetch } from '../../../hooks/useFetch';

// fields
import { Select, SelectProps } from '../Select/Select';

export const SelectTags = ({ ...props }: SelectProps) => {
	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// hooks
	const { t } = useTranslation();

	// context
	const { project } = useContext(ContextProject);

	// state
	const [tags, setTags] = useState<Tag[]>(props.value as Tag[]);

	// fetch tags
	useFetch({
		isEnabled: Boolean(project?.id),
		url: `${process.env.REACT_APP_API_URL}/tags?project=${project?.id}&fields=id,name&orderBy=name&order=ASC`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data) {
				setTags(res.data);
			}
		},
	});

	const optionsTags = tags.map((tag) => {
		return {
			label: tag.name,
			value: String(tag.id),
		};
	});

	return <Select label={t('tags')} multiple={true} name="tags" options={optionsTags} {...props} />;
};
